import { useEffect, useState } from "react";

import Schemas from "schemas";
import * as yup from "yup";

import { useStorageListener } from "./useStorage";

const useProfileInfoCompleted = () => {
    const myUniversityId = useStorageListener("myUniversityId");
    const details = useStorageListener(`universities.${myUniversityId}.details`, {});
    const [isValid, setIsValid] = useState(false);
    const [validated, setValidated] = useState(false);
    // @ts-ignore
    useEffect(async () => {
        try {
            await Schemas.uniProfileInfo(yup)?.validate?.(details, { abortEarly: false });
            setIsValid(true);
        } catch (error) {
            setIsValid(false);
        } finally {
            setValidated(true);
        }
    }, [details]);
    if (validated) {
        return isValid;
    }
};

export default useProfileInfoCompleted;
